import * as occlTemplates from '@src/components/templates/occl/index.js';

type TemplatesType = typeof occlTemplates;

export const templates = {
  occl: occlTemplates as unknown as TemplatesType,
};
